import { render, staticRenderFns } from "./index--import-information.vue?vue&type=template&id=cab1e2b6&"
import script from "./index--import-information.vue?vue&type=script&lang=js&"
export * from "./index--import-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports